import { motion } from "framer-motion";
import { Image as ImageIcon } from "lucide-react";

export const Reveal = ({ children, delay = 0, y = 40, className = "", testId }) => (
  <motion.div
    className={className}
    data-testid={testId}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, testId }) => (
  <p
    data-testid={testId}
    className="font-heading text-xs font-semibold tracking-[0.28em] uppercase text-[#00867A]/70 mb-5"
  >
    {children}
  </p>
);

export const ImageSlot = ({ label = "Photo", className = "", testId }) => (
  <div
    data-testid={testId}
    className={`w-full h-full min-h-[300px] bg-[#F3EFE5] border-2 border-dashed border-[#00867A]/30 flex flex-col items-center justify-center ${className}`}
  >
    <ImageIcon className="w-8 h-8 text-[#00867A]/35" strokeWidth={1.5} />
    <span className="mt-3 font-heading text-[#00867A]/55 font-medium tracking-[0.22em] uppercase text-[11px]">
      {label}
    </span>
  </div>
);

export const Marquee = ({ phrases, testId }) => {
  const chunk = (phrases.join("  ·  ") + "  ·  ").repeat(4);
  return (
    <div className="marquee-ribbon" data-testid={testId} aria-hidden="true">
      <div className="marquee-track">
        <span className="marquee-chunk">{chunk}</span>
        <span className="marquee-chunk">{chunk}</span>
      </div>
    </div>
  );
};
